var _a;
import { ProductOptions } from 'generated/types';
import { enumValuesFactory } from 'utils/objectHelper';
var enumDescriptionMap = (_a = {},
    _a[ProductOptions.CoreAndPbm] = 'Joint (PBM + Nav)',
    _a[ProductOptions.OnlyCore] = 'Nav Only',
    _a[ProductOptions.OnlyPbm] = 'PBM Only',
    _a);
export var ProductOptionsEnum = {
    name: 'Ticket_State_Priority',
    enumValues: enumValuesFactory(enumDescriptionMap)
};
